<div class="d-flex align-items-center" >
  <ds-input [label]="'testing_tool' | translate" [state]="DsInputStates.inline">
    <select ds-input-field [(ngModel)]="currentValue" (ngModelChange)="onToolSelect($event)">
      <option *ngFor="let auditToolName of toolsToList" [value]="auditToolName">
        {{ 'scan_results_tool_option_' + auditToolName | translate }}
      </option>
    </select>
  </ds-input>
</div>
